import { parser } from "./parser";
import { walkTree } from "./parse-utils";
export function parseErrors(doc) {
    const tree = parser.parse(doc);
    const errors = [];
    const cursor = tree.cursor();
    walkTree(cursor, () => {
        if (cursor.type.isError || cursor.type.name === "⚠") {
            errors.push({
                type: "ParseError",
                message: "Parse error",
                start: cursor.from,
                end: cursor.to,
            });
        }
    });
    return errors;
}
